import React, { useState } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import './MultipleChoiceQuestion.css';

/**
 * Drag and Drop Question Component
 * Reorder items or categorize them
 */
export function DragDropQuestion({ question, value = [], onChange, disabled = false, showCorrect = false }) {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const items = question?.items || [];
  // Value should be array of item IDs in user's order
  const currentOrder = value.length > 0 ? value : items.map(item => item.id);
  const correctOrder = question?.correctAnswer || items.map(item => item.id);

  const handleDragStart = (e, index) => {
    if (disabled) return;
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (disabled || draggedIndex === null || draggedIndex === dropIndex) return;

    const newOrder = [...currentOrder];
    const draggedId = newOrder[draggedIndex];
    newOrder.splice(draggedIndex, 1);
    newOrder.splice(dropIndex, 0, draggedId);
    
    onChange(newOrder);
    setDraggedIndex(null);
  };

  const getItemStatus = (itemId, index) => {
    if (!showCorrect || correctOrder.length === 0) return '';
    const isCorrectPosition = correctOrder[index] === itemId;
    return isCorrectPosition ? 'option-correct' : 'option-incorrect';
  };

  const getItemById = (itemId) => {
    return items.find(item => item.id === itemId);
  };

  return (
    <div className="drag-drop-question">
      <div className="mb-3 text-muted small">
        <i className="bi bi-info-circle"></i> Drag and drop to reorder the items correctly
      </div>
      <ListGroup>
        {currentOrder.map((itemId, index) => {
          const item = getItemById(itemId);
          if (!item) return null;
          
          const isDragging = draggedIndex === index;
          const status = getItemStatus(itemId, index);
          
          return (
            <ListGroup.Item
              key={`${itemId}-${index}`}
              draggable={!disabled}
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDrop={(e) => handleDrop(e, index)}
              className={`drag-drop-item ${isDragging ? 'dragging' : ''} ${status} ${disabled ? 'disabled' : ''}`}
              style={{ cursor: disabled ? 'default' : 'move' }}
            >
              <div className="d-flex align-items-center">
                {!disabled && (
                  <span className="drag-handle me-3">
                    <i className="bi bi-grip-vertical"></i>
                  </span>
                )}
                <span className="item-number me-3 text-muted">
                  {index + 1}.
                </span>
                <span className="flex-grow-1">
                  {item.text}
                </span>
                {showCorrect && status === 'option-correct' && (
                  <i className="bi bi-check-circle-fill text-success"></i>
                )}
                {showCorrect && status === 'option-incorrect' && (
                  <i className="bi bi-x-circle-fill text-danger"></i>
                )}
              </div>
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </div>
  );
}
